import * as React from 'react';
import { Icon } from '../Icon/Icon';
import { HeaderMenu, type IHeaderMenuProps } from './HeaderMenu';
import { type IMobileMenuProps, MobileMenu } from './MobileMenu';
import { type IMobileMenuOverlayProps, MobileMenuOverlay } from './MobileMenuOverlay';
import { type IRegionSelectorProps, RegionSelector } from './RegionSelector';

export interface IHeaderProps {
    headermenu: IHeaderMenuProps;
    regionselector: IRegionSelectorProps;
    mobilemenu: IMobileMenuProps;
    mobileoverlay: IMobileMenuOverlayProps;
}

interface IHeaderState {
    mobileopen: boolean;
    classname: string;
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {
    constructor(props: IHeaderProps) {
        super(props);
        this.state = { mobileopen: false, classname: 'mobile-header' };
    }

    toggledMobile(): void {
        this.setState({ mobileopen: !this.state.mobileopen });
        const open = this.state.mobileopen;

        if (!open) {
            document.querySelector('body').className += ' hasmobileoverlay';
            this.setState({ classname: 'd-flex flex-column top-menu mobile-header' });
        } else {
            document.querySelector('body').classList.remove('hasmobileoverlay');
            this.setState({ classname: 'mobile-header' });
        }
    }

    render(): JSX.Element {
        return (
            <div className={this.state.classname}>
                <div className="header">
                    <div className="container header__container">
                        <div className="header__content d-flex justify-content-between align-items-center">
                            <div className="d-flex">
                                <div className="header__logo align-items-center">
                                    <a href={this.props.regionselector.currentRegion.url} aria-label="Gå till startsidan">
                                        <div className="header__logo_image" role="banner">
                                            <Icon symbol="trafiken_nu_logo" />
                                        </div>
                                    </a>
                                </div>
                                <div className="align-items-center">
                                    <RegionSelector
                                        currentRegion={this.props.regionselector.currentRegion}
                                        otherRegions={this.props.regionselector.otherRegions}
                                    />
                                </div>
                            </div>
                            <div className="d-none d-lg-block header__menu">
                                <HeaderMenu {...this.props.headermenu} />
                            </div>
                            <div className="d-lg-none">
                                <MobileMenu toggledmobile={this.toggledMobile.bind(this)}></MobileMenu>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.mobileopen ? (
                    <MobileMenuOverlay items={this.props.mobileoverlay.items} searchUrl={this.props.mobileoverlay.searchUrl} />
                ) : null}
            </div>
        );
    }
}
